import { Icons } from "../../assets/icons";
import { Tooltip } from "antd";

function SpotIcon({
  width = 72,
  height = 72,
  color,
  position = "right",
  children,
  onClick,
  disabled = false,
  disabledMessage = "Complete previous steps first",
  isNextAvailable = false,
  isCompleted = false,
  centerIcon,
}: {
  width?: number;
  height?: number;
  color: "red" | "green" | "yellow" | "purple" | "black";
  position?: "right" | "left" | "top" | "bottom";
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  disabledMessage?: string;
  isNextAvailable?: boolean;
  isCompleted?: boolean;
  centerIcon: React.ReactNode;
}) {
  const mapPinIconColor = (
    color: "red" | "green" | "yellow" | "purple" | "black",
  ) => {
    const getColorClass = (
      color: "red" | "green" | "yellow" | "purple" | "black",
    ) => {
      switch (color) {
        case "red":
          return "bg-red-800";
        case "green":
          return "bg-green-800";
        case "yellow":
          return "bg-yellow-800";
        case "purple":
          return "bg-purple-800";
        case "black":
          return "bg-black";
      }
    };

    return (
      <div className="relative">
        <div
          className={`absolute left-1/2 top-1/2 h-8 w-8 -translate-x-1/2 -translate-y-[100%] rounded-full ${getColorClass(color)} flex items-center justify-center`}
        >
          {centerIcon}
        </div>
        {(() => {
          switch (color) {
            case "red":
              return <Icons.PinIconRed width={width} height={height} />;
            case "green":
              return <Icons.PinIconGreen width={width} height={height} />;
            case "yellow":
              return <Icons.PinIconYellow width={width} height={height} />;
            case "purple":
              return <Icons.PinIconPurple width={width} height={height} />;
            case "black":
              return <Icons.PinIconRed width={width} height={height} />;
          }
        })()}
      </div>
    );
  };

  const iconElement = (
    <div
      className={`${disabled ? "cursor-not-allowed opacity-95" : "cursor-pointer"} ${
        isNextAvailable ? "animate-bounce" : ""
      } relative`}
      style={
        isNextAvailable
          ? {
              transform: "scale(0.8)",
              animation: "bounce 1s ease-in-out infinite",
            }
          : undefined
      }
      onClick={!disabled ? onClick : undefined}
    >
      {mapPinIconColor(color)}
      {isCompleted && (
        <div className="absolute -right-2 -top-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-green-500"
            viewBox="0 0 20 20"
            fill="currentColor"
            strokeWidth="2"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      )}
    </div>
  );

  return (
    <div className={`${getContainerClassName(position)} `}>
      {disabled ? (
        <Tooltip title={disabledMessage}>{iconElement}</Tooltip>
      ) : (
        iconElement
      )}
      <>{children}</>
    </div>
  );
}

const getContainerClassName = (
  position: "right" | "left" | "top" | "bottom",
) => {
  const baseClasses = "flex items-center justify-center";
  switch (position) {
    case "right":
      return `${baseClasses} flex-row`;
    case "left":
      return `${baseClasses} flex-row-reverse`;
    case "top":
      return `${baseClasses} flex-col-reverse`;
    case "bottom":
      return `${baseClasses} flex-col`;
    default:
      return baseClasses;
  }
};

export default SpotIcon;
